import styled from "styled-components"

const MenuPlato = styled.div`
  background: linear-gradient(180deg, #042539 0%, #010C13 100%);
`

export default MenuPlato